import { Color3 } from '@babylonjs/core';

export interface BlockFaces {
  top: number;
  bottom: number;
  north: number;
  south: number;
  east: number;
  west: number;
}

export interface BlockDefinition {
  id: number;
  name: string;
  displayName: string;
  color: Color3;
  transparent: boolean;
  solid: boolean;
  textureIndex?: BlockFaces | number;
}

export class Block {
  public static readonly AIR = 0;
  public static readonly GRASS = 1;
  public static readonly DIRT = 2;
  public static readonly STONE = 3;
  public static readonly WOOD = 4;
  public static readonly LEAVES = 5;
  public static readonly SAND = 6;
  public static readonly WATER = 7;
  public static readonly BRICK = 8;
  public static readonly GLASS = 9;
  public static readonly COBBLESTONE = 10;
  public static readonly PLANKS = 11;
  public static readonly GOLD = 12;
  public static readonly IRON = 13;
  public static readonly DIAMOND = 14;
  public static readonly BEDROCK = 15;

  private constructor() {}

  public static isTransparent(blockId: number): boolean {
    return blockId === Block.AIR || blockId === Block.WATER || blockId === Block.GLASS || blockId === Block.LEAVES;
  }

  public static isSolid(blockId: number): boolean {
    return blockId !== Block.AIR && blockId !== Block.WATER;
  }

  public static isLiquid(blockId: number): boolean {
    return blockId === Block.WATER;
  }
}
